import type { Components, Theme } from '@mui/material/styles'

import { surfaces } from '@/theme/palette'

export const components: Components<Theme> = {
  MuiCssBaseline: {
    styleOverrides: {
      '*, *::before, *::after': { boxSizing: 'border-box' },
      html: { colorScheme: 'dark' },
      body: {
        backgroundColor: surfaces.canvas,
        backgroundImage:
          'radial-gradient(ellipse 120% 60% at 50% -10%, rgba(76,111,255,0.10) 0%, rgba(8,11,18,0) 60%)',
        backgroundAttachment: 'fixed',
      },
      '::-webkit-scrollbar': { width: 8, height: 8 },
      '::-webkit-scrollbar-track': { background: 'transparent' },
      '::-webkit-scrollbar-thumb': {
        background: 'rgba(148, 163, 184, 0.25)',
        borderRadius: 8,
      },
      '::-webkit-scrollbar-thumb:hover': { background: 'rgba(148, 163, 184, 0.4)' },
    },
  },
  MuiPaper: {
    defaultProps: { elevation: 0 },
    styleOverrides: {
      root: {
        backgroundImage: 'none',
        backgroundColor: surfaces.card,
      },
    },
  },
  MuiCard: {
    defaultProps: { elevation: 0 },
    styleOverrides: {
      root: {
        backgroundColor: surfaces.card,
        border: `1px solid ${surfaces.border}`,
        borderRadius: 14,
        backgroundImage: surfaces.gradientSubtle,
      },
    },
  },
  MuiAppBar: {
    styleOverrides: {
      root: {
        backgroundColor: 'rgba(10, 14, 24, 0.72)',
        backdropFilter: 'blur(12px)',
        backgroundImage: 'none',
        borderBottom: `1px solid ${surfaces.border}`,
      },
    },
  },
  MuiDrawer: {
    styleOverrides: {
      paper: {
        backgroundColor: surfaces.sidebar,
        backgroundImage: 'none',
        borderRight: `1px solid ${surfaces.border}`,
      },
    },
  },
  MuiButton: {
    defaultProps: { disableElevation: true },
    styleOverrides: {
      root: {
        borderRadius: 10,
        paddingInline: 16,
        paddingBlock: 8.5,
        transition: 'background-color 180ms ease, border-color 180ms ease, opacity 180ms ease',
      },
      outlined: {
        borderColor: surfaces.borderStrong,
      },
    },
    variants: [
      {
        props: { variant: 'contained', color: 'primary' },
        style: { backgroundImage: surfaces.gradientPrimary },
      },
    ],
  },
  MuiIconButton: {
    styleOverrides: {
      root: {
        transition: 'background-color 180ms ease, color 180ms ease',
      },
    },
  },
  MuiChip: {
    styleOverrides: {
      root: { borderRadius: 8, fontWeight: 600, transition: 'background-color 180ms ease, border-color 180ms ease' },
    },
  },
  MuiTextField: {
    defaultProps: { size: 'small' },
  },
  MuiOutlinedInput: {
    styleOverrides: {
      root: { borderRadius: 10 },
      notchedOutline: { borderColor: surfaces.borderStrong, transition: 'border-color 180ms ease' },
    },
  },
  MuiTableCell: {
    styleOverrides: {
      root: { borderColor: surfaces.border },
    },
  },
  MuiTooltip: {
    styleOverrides: {
      tooltip: {
        backgroundColor: surfaces.cardElevated,
        border: `1px solid ${surfaces.border}`,
        fontSize: '0.75rem',
      },
    },
  },
  MuiDivider: {
    styleOverrides: {
      root: { borderColor: surfaces.border },
    },
  },
  MuiListItemButton: {
    styleOverrides: {
      root: {
        borderRadius: 10,
        transition: 'background-color 180ms ease, opacity 180ms ease',
        '&:hover': {
          backgroundColor: 'rgba(148, 163, 184, 0.08)',
        },
        '&.Mui-selected': {
          backgroundColor: 'rgba(76, 111, 255, 0.14)',
        },
        '&.Mui-selected:hover': {
          backgroundColor: 'rgba(76, 111, 255, 0.20)',
        },
        '&.Mui-focusVisible': {
          outline: '2px solid rgba(76, 111, 255, 0.55)',
          outlineOffset: 2,
        },
      },
    },
  },
}
